import { StateContainer } from 'straightline-ui';

const stateContainer = new StateContainer({
  shipper: null,
  user: null,
  authenticated: false,
  prepped: false
});

export default stateContainer;
